var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEmailReminder24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5a.5.5 0 01.5-.5h14a.5.5 0 01.5.5v3.629a.5.5 0 001 0V5A1.5 1.5 0 0018 3.5H4A1.5 1.5 0 002.5 5v10A1.5 1.5 0 004 16.5h6.533a.5.5 0 100-1H4a.5.5 0 01-.5-.5V5zm14.72 7.262a.5.5 0 01.822-.382l1.72 1.45a.5.5 0 01-.006.769l-1.719 1.414a.5.5 0 01-.817-.386V14.2a3 3 0 103.08 3 .5.5 0 111 0 4 4 0 11-4.08-4v-.938z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61 6.689a.5.5 0 01.702-.078L11 10.361l4.688-3.75a.5.5 0 11.624.78l-5 4a.5.5 0 01-.624 0l-1.501-1.2-2.815 3.143a.5.5 0 01-.744-.668l2.777-3.1-2.717-2.174a.5.5 0 01-.078-.703z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailReminder24);
export default __webpack_public_path__ + "static/media/icon-email-reminder-24.feb4b01e.svg";
export { ForwardRef as ReactComponent };